import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../../../core/services/notification/notification.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { TransactionResult } from '../../../../../core/services/interfaces/transaction-result';
import { IActivities } from '../../Interfaces/IActivities';
import { ActivitiesService } from '../../services/activities-services';
import { EHSExamsService } from '../../services/ehsExams-services';
import { DatePipe } from '@angular/common';
import { TranslateApplicationService } from '../../../../../core/translate/translate-application-service';
import { IEHSExams } from '../../Interfaces/IEHSExams';

@Component({
  selector: 'activity-assign-exam',
  templateUrl: 'activity-assign-exam.html',
  styleUrls: ['../activities.component.scss']
})
export class ActiviyAssignExam {
  formGroup: FormGroup;
  listData: IEHSExams[];
  listDataAvailable: IEHSExams[] = [];
  listEHSExamActivityData: IEHSExams[];
  loading = false;
  station: string = 'TABLE';
  columns: Array<any> = ['ehsexamname', 'disablecolumn'];
  displayedColumns: Array<string> = this.columns.map(c => c.columnDef);

  constructor(
    private dialogRef: MatDialogRef<ActiviyAssignExam>,
    @Inject(MAT_DIALOG_DATA) public data: IActivities,
    private notificationService: NotificationService,
    private EHSExamsService: EHSExamsService,
    private activityService: ActivitiesService,
    private ehsExamService: EHSExamsService,
    private datePipe: DatePipe,
    private formBuilder: FormBuilder,
    public translate: TranslateApplicationService
  ) {
    this.formGroup = this.formBuilder.group({
      pkactivity: [data.pkactivity, Validators.required],
      fkehsexam: [null, Validators.required],
    });
  }
  
  ngOnInit() {
    this.GetAEHSExams();
    this.GetAEHSExamsByActivity();
  }
  
  GetAEHSExams() {
    this.loading = true;
    this.ehsExamService.GetList().subscribe( 
      (result: TransactionResult<IEHSExams[]>) => {
        this.loading = false;
        if (result.success) {
          result.data.forEach((element)=>{
            if(element.available)
              this.listDataAvailable.push(element);
          });
          this.listData = this.ValidatePassingPoints(this.listDataAvailable);
        }
        else{
          this.ErrorMessage('ACTIVITIES.Exams_not_found');
        }
      },
      (error: any) => { 
        this.ErrorAlert(error); this.loading = false; 
      });
  }

  ValidatePassingPoints(data: any)
	{
    this.loading = true;
    let arr:IEHSExams[] =[];
		data.forEach((element) => {
			this.EHSExamsService.GetPassingScoreValidation(element).subscribe(
			(result: TransactionResult<boolean>) => {
				if(result){
          arr.push(element);
          this.loading = false;
        }
        else{
          this.loading = false;
          //this.ErrorMessage('ACTIVITIES.Error_passing_points')
        } 
			});
    },
    (error) => {
      this.loading = false;
      this.ErrorAlert(error);
    });
    
    return arr;
	}

  GetAEHSExamsByActivity() {
    this.loading = true;
    this.activityService.GetEHSExamsByActivity(this.formGroup.value).subscribe( 
    (result: TransactionResult<IEHSExams[]>) => {
      if (result.success) {
        this.loading = false;
        this.listEHSExamActivityData = result.data;
      }
      else{
        this.loading = false;
        this.ErrorMessage('Activities.Error_exams_by_activity')
      }
    },
    (error: any) => { 
      this.ErrorAlert(error); this.loading = false; 
    });
  }

  AddEHSExam(){
    this.loading = true;
    if (this.formGroup.valid) {
      this.loading = true;
      this.activityService.AddEHSExam(this.formGroup.value).subscribe(
      (result: TransactionResult<boolean>) => {
        if (result.success) { 
          this.loading = false;
          this.Alert(); 
          this.formGroup.controls.fkehsexam.setValue(0);
          this.GetAEHSExamsByActivity();
        }
        else {
          this.loading = false;
          this.ErrorMessage('ACTIVITIES.Error_add_exam');
        }
      },
      (error: any) => { 
        this.ErrorAlert(error); this.loading = false; 
      });
    }
    else{
      this.loading = false;
      this.notificationService.AddAlert({
        icon: 'all_inbox',
        title: 'Warning',
        message: this.translate.TranslateKey('COMPLETE_FORM'),
        shown: true
      });
    }
  }

  DisableExam(item: IActivities){
    this.activityService.DisableEHSExam(item).subscribe(
    (result: TransactionResult<boolean>) => {
      if (result.data)
      { 
        this.loading = false;
        this.GetAEHSExamsByActivity();
        this.Alert(); 
      }
      else{
        this.loading = false;
        this.ErrorMessage('ACTIVITIES.Error_disable_exam');
      }
    },
    (error: any) => { 
      this.ErrorAlert(error); this.loading = false; 
    });
  }

  Close() {
    this.dialogRef.close(false);
  }

  Alert() {
    this.notificationService.AddAlert({
      icon: 'all_inbox',
      title: 'Success',
      message: this.translate.TranslateKey('COMPLETE'),
      shown: true
    });
  }

  ErrorAlert(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: message,
			shown: true,
		});
  }

  ErrorMessage(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: this.translate.TranslateKey(message),
			shown: true,
		});
  }

}
